export default __webpack_public_path__ + "static/thecloudors-intro-a1f85431c815db83766b5cba9c41241e.mp4";